import { Helmet } from "react-helmet-async";
import Layout from "../components/Layout";
import PageText from "../components/PageText";
import PageTitle from "../components/PageTitle";
import SpotlightPost from "./blog/SpotlightPost";
import AllGameplayPost from "./blog/AllGameplayPost";

export default function Blog() {
  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://chaotik.org/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Blog",
        item: "https://chaotik.org/blog",
      },
    ],
  };

  return (
    <Layout>
      <Helmet>
        <title>CHAOTIK Blog | Star Citizen Org Updates</title>
        <meta
          name="description"
          content="Updates from CHAOTIK, a 24/7 multi-role Star Citizen organization. Spotlight features, philosophy posts, and notes from across EU/US/AUS."
        />
        <link rel="canonical" href="https://chaotik.org/blog" />
        <meta property="og:title" content="CHAOTIK Blog | Star Citizen Org Updates" />
        <meta
          property="og:description"
          content="Updates from CHAOTIK, a 24/7 multi-role Star Citizen organization. Spotlight features, philosophy posts, and notes from the verse."
        />
        <meta property="og:url" content="https://chaotik.org/blog" />
        <meta name="twitter:title" content="CHAOTIK Blog | Star Citizen Org Updates" />
        <meta
          name="twitter:description"
          content="Updates from CHAOTIK, a 24/7 multi-role Star Citizen organization. Spotlight features, philosophy posts, and notes from the verse."
        />
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      </Helmet>

      <div className="flex flex-col items-center mt-10 sm:mt-14 mb-24 px-2">
        <div className="w-full max-w-4xl text-center mb-12">
          <PageTitle>CHAOTIK Blog</PageTitle>
          <PageText>
            <p className="text-center break-normal p-2 sm:p-4">
              Notes, updates and the occasional manifesto from a 24/7 multi-role Star Citizen org.
            </p>
          </PageText>
        </div>

        <div className="w-full max-w-4xl">
          <SpotlightPost />
          <AllGameplayPost />
        </div>
      </div>
    </Layout>
  );
}
